import { useState, useEffect } from "react";
import { FaChevronLeft, FaTh, FaList } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import Modal from "../../components/Modal";
import AddVehicle from "../../forms/vehicle/AddVehicle";

import { GetVehicle } from "../../Services";

const VehicleListByDriver = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { driver } = location.state || {};

  const [vehicles, setVehicles] = useState([]);
  const [filteredVehicles, setFilteredVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingVehicle, setEditingVehicle] = useState(null);
  const [viewMode, setViewMode] = useState("grid");
  const [searchTerm, setSearchTerm] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: "id", direction: "asc" });
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  // Initialize Bootstrap tooltips
  useEffect(() => {
    const tooltipTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    tooltipTriggerList.forEach((tooltipTriggerEl) => {
      new window.bootstrap.Tooltip(tooltipTriggerEl);
    });
  }, [filteredVehicles]);

  useEffect(() => {
    const fetchDispatchers = async () => {
      setLoading(true);
      try {
        const data = await GetVehicle.fetchVehicleByID(driver.id);
        setVehicles(Array.isArray(data) ? data : []);
        setFilteredVehicles(data);

        // console.log("Vehicles", data);
      } catch (error) {
        console.error("Error fetching dispatcher:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchDispatchers();
  }, []);

  // Fetch vehicles
  // useEffect(() => {
  //   if (!driver?.id) {
  //     setLoading(false);
  //     return;
  //   }

  //   const abortController = new AbortController();

  //   const fetchVehicles = async () => {
  //     try {
  //       const res = await axios.get(
  //         `https://binberu.idaprocharity.com/api/v1/admin/get-vehicle-by-id/${driver.id}`,
  //         { signal: abortController.signal }
  //       );
  //       const data = res.data.data || res.data;
  //       setVehicles(data);
  //       setFilteredVehicles(data);

  //       // console.log("Vehicles:", data);
  //     } catch (error) {
  //       if (error.name !== "AbortError") {
  //         console.error("Error fetching vehicles:", error);
  //         toast.error("Failed to fetch vehicles", {
  //           position: "top-right",
  //           autoClose: 3000,
  //         });
  //       }
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchVehicles();

  //   return () => abortController.abort();
  // }, [driver?.id]);

  // Handle search
  useEffect(() => {
    const filtered = vehicles.filter(
      (v) =>
        v.plate_no?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        v.model?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        v.owner_name?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredVehicles(filtered);
    setCurrentPage(1);
  }, [searchTerm, vehicles]);

  // Handle sort
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });

    const sorted = [...filteredVehicles].sort((a, b) => {
      if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
      if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
      return 0;
    });
    setFilteredVehicles(sorted);
  };

  // Handle delete
  const handleDelete = async (vehicleId) => {
    if (!window.confirm("Are you sure you want to delete this vehicle?"))
      return;

    try {
      await axios.delete(
        `https://binberu.idaprocharity.com/api/v1/admin/delete-vehicle/${vehicleId}`
      );
      setVehicles((prev) => prev.filter((v) => v.id !== vehicleId));
      setFilteredVehicles((prev) => prev.filter((v) => v.id !== vehicleId));
      toast.success("Vehicle deleted successfully!", {
        position: "top-right",
        autoClose: 3000,
      });
    } catch (error) {
      console.error("Error deleting vehicle:", error);
      toast.error(error.response?.data?.message || "Failed to delete vehicle", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };

  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredVehicles.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const totalPages = Math.ceil(filteredVehicles.length / itemsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const renderVehicles = () => {
    if (loading) return <p>Loading vehicles...</p>;
    if (currentItems.length === 0)
      return <p>No vehicles found for this driver.</p>;

    if (viewMode === "grid") {
      return (
        <div className="row">
          {currentItems.map((v) => (
            <div key={v.id} className="col-md-4 col-12 mb-3">
              <div className="card vehicle-card">
                <div className="card-body">
                  <h5 className="card-title">{v.plate_no}</h5>
                  {v.photo_url && (
                    <img
                      src={v.photo_url}
                      alt={`${v.plate_no} photo`}
                      className="photo-preview mb-2"
                    />
                  )}
                  <p className="card-text">
                    <strong>Model:</strong> {v.model}
                    <br />
                    <strong>Year:</strong> {v.year}
                    <br />
                    <strong>Color:</strong> {v.color}
                    <br />
                    <strong>Type:</strong> {v.vehicle_type}
                    <br />
                    <strong>Owner:</strong> {v.owner_name}
                    <br />
                    <strong>Insurance:</strong>{" "}
                    <span
                      className="insurance-status"
                      style={{
                        color: v.insurance_status ? "green" : "red",
                        backgroundColor: v.insurance_status
                          ? "#d4edda"
                          : "#f8d7da",
                      }}
                    >
                      {v.insurance_status ? "Active" : "Expired"}
                    </span>
                  </p>
                  <div className="d-flex gap-2">
                    <button
                      className="btn btn-sm btn-outline-primary px-2 py-1"
                      onClick={() => {
                        setEditingVehicle(v);
                        setShowModal(true);
                      }}
                      data-bs-toggle="tooltip"
                      title="Edit"
                      aria-label="Edit vehicle"
                    >
                      <i className="fas fa-edit" />
                    </button>
                    <button
                      className="btn btn-sm btn-outline-danger px-2 py-1 ml-2"
                      onClick={() => handleDelete(v.id)}
                      data-bs-toggle="tooltip"
                      title="Delete"
                      aria-label="Delete vehicle"
                    >
                      <i className="fas fa-trash" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      );
    }

    return (
      <div className="list-group">
        {currentItems.map((v) => (
          <div key={v.id} className="list-group-item vehicle-list-item">
            <div>
              <strong>{v.plate_no}</strong> ({v.model}, {v.year})<br />
              {v.photo_url && (
                <img
                  src={v.photo_url}
                  alt={`${v.plate_no} photo`}
                  className="photo-preview mb-2"
                />
              )}
              <small>
                Color: {v.color} | Type: {v.vehicle_type} | Owner:{" "}
                {v.owner_name} |{" "}
                <span
                  className="insurance-status"
                  style={{
                    color: v.insurance_status ? "green" : "red",
                    backgroundColor: v.insurance_status ? "#d4edda" : "#f8d7da",
                  }}
                >
                  Insurance: {v.insurance_status ? "Active" : "Expired"}
                </span>
              </small>
            </div>
            <div className="d-flex gap-2">
              <button
                className="btn btn-sm btn-outline-primary px-2 py-1"
                onClick={() => {
                  setEditingVehicle(v);
                  setShowModal(true);
                }}
                data-bs-toggle="tooltip"
                title="Edit"
                aria-label="Edit vehicle"
              >
                <i className="fas fa-edit" />
              </button>
              <button
                className="btn btn-sm btn-outline-danger px-2 py-1 ml-2"
                onClick={() => handleDelete(v.id)}
                data-bs-toggle="tooltip"
                title="Delete"
                aria-label="Delete vehicle"
              >
                <i className="fas fa-trash" />
              </button>
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="content-wrapper p-4">
      <h2 className="text-2xl font-bold">
        Vehicle list of {driver ? driver.name : "Driver"} /{" "}
        {driver ? driver.email : "Driver"}
      </h2>
      <div className="card shadow-md">
        <div className="d-flex justify-content-between align-items-center mb-4 p-4">
          <div className="d-flex gap-2">
            <button
              type="button"
              onClick={() => {
                setEditingVehicle(null);
                setShowModal(true);
              }}
              className="btn btn-sm btn-primary flex items-center gap-2"
              data-bs-toggle="tooltip"
              title="Add Vehicle"
              aria-label="Add Vehicle"
            >
              <i className="fas fa-car" /> Add Vehicle
            </button>
            <button
              type="button"
              onClick={() => navigate("/drivers")}
              className="btn btn-sm btn-outline-secondary flex items-center ml-2"
              data-bs-toggle="tooltip"
              // title="Back to Drivers"
              aria-label="Back to Drivers"
            >
              <FaChevronLeft /> Back
            </button>
          </div>
          {/* <div className="ms-auto flex gap-2"> */}
          <div>
            {" "}
            <button
              type="button"
              className={`btn btn-sm btn-outline-secondary px-2 py-1 ${
                viewMode === "grid" ? "active" : ""
              }`}
              onClick={() => setViewMode("grid")}
              data-bs-toggle="tooltip"
              title="Grid View"
              aria-label="Grid View"
            >
              <FaTh />
            </button>
            <button
              type="button"
              className={`btn btn-sm btn-outline-secondary px-2 py-1 ml-2 ${
                viewMode === "list" ? "active" : ""
              }`}
              onClick={() => setViewMode("list")}
              data-bs-toggle="tooltip"
              title="List View"
              aria-label="List View"
            >
              <FaList />
            </button>
          </div>
          {/* </div> */}
        </div>

        <Modal showModal={showModal} setShowModal={setShowModal}>
          <AddVehicle
            editingVehicle={editingVehicle}
            setEditingVehicle={setEditingVehicle}
            setVehicles={setVehicles}
            setShowModal={setShowModal}
            driverId={driver?.id}
          />
        </Modal>

        <div className="card-body p-4">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div className="d-flex gap-2">
              <button
                type="button"
                className="btn btn-sm btn-outline-secondary"
                onClick={() => alert("CSV export not implemented")}
                data-bs-toggle="tooltip"
                title="Export as CSV"
                aria-label="Export as CSV"
              >
                CSV
              </button>
              <button
                type="button"
                className="btn btn-sm btn-outline-secondary ml-2"
                onClick={() => alert("Excel export not implemented")}
                data-bs-toggle="tooltip"
                title="Export as Excel"
                aria-label="Export as Excel"
              >
                Excel
              </button>
              <button
                type="button"
                className="btn btn-sm btn-outline-secondary ml-2"
                onClick={() => alert("PDF export not implemented")}
                data-bs-toggle="tooltip"
                title="Export as PDF"
                aria-label="Export as PDF"
              >
                PDF
              </button>
            </div>
            <input
              type="text"
              className="form-control"
              placeholder="Search by plate, model, or owner..."
              style={{ width: "300px" }}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          <div className="d-flex justify-content-between align-items-center mb-3">
            <div>
              <button
                className="btn btn-link p-0"
                onClick={() => handleSort("id")}
              >
                ID{" "}
                {sortConfig.key === "id" &&
                  (sortConfig.direction === "asc" ? "↑" : "↓")}
              </button>
              <button
                className="btn btn-link p-0 ms-3"
                onClick={() => handleSort("plate_no")}
              >
                Plate No{" "}
                {sortConfig.key === "plate_no" &&
                  (sortConfig.direction === "asc" ? "↑" : "↓")}
              </button>
              <button
                className="btn btn-link p-0 ms-3"
                onClick={() => handleSort("year")}
              >
                Year{" "}
                {sortConfig.key === "year" &&
                  (sortConfig.direction === "asc" ? "↑" : "↓")}
              </button>
            </div>
          </div>

          {renderVehicles()}

          {filteredVehicles.length > itemsPerPage && (
            <div className="pagination mt-4">
              <button
                className="btn btn-sm btn-outline-secondary"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
                aria-label="Previous page"
              >
                Previous
              </button>
              {[...Array(totalPages)].map((_, i) => (
                <button
                  key={i + 1}
                  className={`btn btn-sm ${
                    currentPage === i + 1
                      ? "btn-primary"
                      : "btn-outline-secondary"
                  }`}
                  onClick={() => handlePageChange(i + 1)}
                  aria-label={`Page ${i + 1}`}
                >
                  {i + 1}
                </button>
              ))}
              <button
                className="btn btn-sm btn-outline-secondary"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                aria-label="Next page"
              >
                Next
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VehicleListByDriver;
